<template>
  <b-modal
    v-model="localIsActive"
    size="lg"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @show="onShow"
    @hide="onHide"
  >
    <template #modal-title>
      Vista validada
    </template>

    <b-table-simple responsive bordered class="mb-0">
      <b-tbody>
        <b-tr>
          <b-th class="table-header text-capitalize">Nombre</b-th>
          <b-td>{{ userView.name }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-card class="my-2" no-body>
      <b-card-body>
        <p class="mb-0 preserve-whitespace">La vista fue validada, por favor cierre y abra nuevamente la vista.</p>
      </b-card-body>
    </b-card>

    <div class="d-flex justify-content-end">
      <b-button variant="primary" @click="onHide()">
        Cerrar
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
  props: {
    userView: {
      type: Object
    },
    showUserViewValidatedModal:{
      type: Boolean
    }
  },
  setup(props, { emit }) {
    //COMPUTED
    const localIsActive = computed({
      get() {
        return props.showUserViewValidatedModal;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    //METHODS
    const onHide = () => {
      emit('update:isActive', false);
    }

    const onShow = () => {

    }

    return {
      localIsActive,

      onHide,
      onShow
    }
  }
}
</script>

<style scoped>

</style>

